if (typeof API_URL === "undefined") {
  const API_URL = "https://app.guideprotection.com/api";
  const API_TOKEN = "1edfee03-af09-6e1c-a731-a5b5e7c20435";
  const WIDGET_HTML = "";

  class CartWatcher {
    init() {
      this.emitCartChanges().then(() => {
        this.observeCartChanges();
      });
    }
    async emitCartChanges() {
      const event = new CustomEvent("cart_changed", { detail: "" });
      window.dispatchEvent(event);
    }

    observeCartChanges() {
      const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          const isValidRequestType = ["xmlhttprequest", "fetch"].includes(
            entry.initiatorType
          );
          const isCartChangeRequest = /\/cart\//.test(entry.name);
          if (isValidRequestType && isCartChangeRequest) {
            this.emitCartChanges();
          }
        });
      });
      cartObserver.observe({ entryTypes: ["resource"] });
    }
  }

  class ShopifyCart {
    async cart() {
      let response = await fetch(`/cart.js`);

      return await response.json();
    }

    async add(id) {
      let response = await fetch(`/cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: id,
              quantity: 1,
            },
          ],
        }),
      });

      response = await response.json();
      return response;
    }

    async update(updates) {
      let response = await fetch(`/cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates: updates,
        }),
      });

      response = await response.json();
      return response;
    }
  }

  class Api {
    constructor(shop) {
      this.shop = shop;
    }

    async variant(cart) {
      const totalAmount =
        cart.items.reduce((acc, item) => {
          if (item.vendor === "Guide") {
            return acc;
          }

          return acc + item.final_line_price;
        }, 0) / 100;

      const response = await fetch(
        `${API_URL}/products/variant?total_amount=${totalAmount}&currency=${cart.currency}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${btoa(API_TOKEN + ":" + this.shop)}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "skip-browser",
          },
        }
      );

      return (await response.json()).variant;
    }

    async getShop() {
      const response = await fetch(`${API_URL}/stores/${this.shop}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${btoa(API_TOKEN + ":" + this.shop)}`,
          "Content-Type": "application/json",
        },
      });

      return await response.json();
    }
  }

  class Widget {
    shopifyCart;
    api;
    shop;
    divElementRef;
    spinnerElementRef;
    openModalElementRef;
    closeModalElementRef;
    widgetElementRoot;
    isCheckedByDefault = false;
    storedWithDefaultUnchecked;
    disclaimerVisibility;
    branding;

    constructor(shop) {
      this.shop = shop;
      this.api = new Api(shop);
      this.storedWithDefaultUnchecked = [
        "gen-z-america.myshopify.com",
        "https://gurunanda.com",
        "mi-one-com.myshopify.com",
      ];
      this.shopifyCart = new ShopifyCart();

      window.Shopify.getVariant = this.api.variant;
      window.Shopify.getCart = this.shopifyCart.cart;
      window.Shopify.updateItemOnCart = this.shopifyCart.update;
      window.Shopify.addItemToCart = this.shopifyCart.add;
    }

    async load() {
      this.initDOM().then(async () => {
        try {
          await this.getBranding();
          this.element();
          this.handleScriptTagSettings();
          console.log("di", this.disclaimerVisibility);

          this.toggleLoader(true);

          const cart = await this.shopifyCart.cart();
          window.Shopify.variant = await this.api.variant(cart);

          await this.change();
          if (!window.Shopify.variant) {
            this.toggleLoader(false, false);
            return;
          }

          await this.mountWidget();

          await this.handleDisclaimerText();
        } catch (err) {
          console.log("err", err);
        } finally {
          console.log('I run')
          this.toggleLoader(false);
        }
      });
    }

    initDOM() {
      return new Promise((resolve) => {
        if (WIDGET_HTML !== "") {
          const findRootElement = () => {
            const rebuyElementRoot = document.querySelector(
              '#rebuy-cart [data-app-target="below_subtotal"]'
            );

            this.widgetElementRoot = document.getElementById(
              "guide_prtection_root"
            );

            if (rebuyElementRoot && !this.widgetElementRoot) {
              this.widgetElementRoot = document.createElement("div");

              this.widgetElementRoot.id = "guide_prtection_root";

              this.widgetElementRoot.style.marginBottom = "15px";
              this.widgetElementRoot.style.justifyContent = "center";
              this.widgetElementRoot.style.alignItems = "center";
              this.widgetElementRoot.style.width = "100%";

              rebuyElementRoot.appendChild(this.widgetElementRoot);
            }

            if (this.widgetElementRoot) {
              this.widgetElementRoot.innerHTML = WIDGET_HTML;

              clearInterval(rootElementExistInterval);
              resolve();
            }
          };

          const rootElementExistInterval = setInterval(findRootElement, 10000);

          findRootElement();
        } else {
          resolve();
        }
      });
    }

    element() {
      window.Shopify.inputElementRef = document.getElementById(
        "guide-protection-checkbox-input"
      );
      window.Shopify.disclaimerElementRef = document.getElementById(
        "guide-protection-disclaimer-box"
      );
      window.Shopify.priceElementRef = document.getElementById(
        "guide-protection-price"
      );
      this.divElementRef = document.getElementById("guide-protection-widget");
      this.disclaimerTextElementRef = document.getElementById(
        "guide-protection-disclaimer_text"
      );
      this.spinnerElementRef = document.getElementById("guide-widget-spinner");
      this.openModalElementRef = document.getElementById(
        "guide-protection-info-icon"
      );
      this.closeModalElementRef = document.getElementById(
        "guideprotection__popupclose"
      );
      this.modalElementRef = document.getElementById(
        "guideprotection__popupscreen"
      );
      this.disclaimerVisibility =
        document.getElementById("guide-protection-disclaimer-visibility")
          ?.value || "unchecked";
    }

    /*
    * You can customize your guide widget using data attributes
    * Example:
        <div id="guide_prtection_root"
            data-checkout-color="#00ff30"
            data-text-color="#ff0300"
            data-info-icon-color="#0000f7"
            data-disclaimer-icon-color="#ff00ff"
            data-disclaimer-text="This is my disclaimer text from dataset to shop |SHOP_NAME|"
            data-use-theme-font="true"
        ></div>
    * To use the default value, just remove the data attribute or leave it blank
    */
    handleScriptTagSettings() {
      if (!this.runningInScriptTag()) {
        return;
      }

      const checkoutColor = this.widgetElementRoot.dataset?.checkoutColor;
      if (checkoutColor && checkoutColor !== "") {
        window.Shopify.inputElementRef.style.color = checkoutColor;
        window.Shopify.inputElementRef.style.accentColor = checkoutColor;
      }

      const textColor = this.widgetElementRoot.dataset?.textColor;
      if (textColor && textColor !== "") {
        Array.from(
          document.getElementsByClassName("guide-protection-setting-text-color")
        ).forEach((element) => (element.style.color = textColor));
      }

      const infoIconColor = this.widgetElementRoot.dataset?.infoIconColor;
      if (infoIconColor && infoIconColor !== "") {
        this.openModalElementRef.style.color = infoIconColor;
      }

      const disclaimerIconColor =
        this.widgetElementRoot.dataset?.disclaimerIconColor;
      if (disclaimerIconColor && disclaimerIconColor !== "") {
        window.Shopify.disclaimerElementRef.querySelector("svg").style.color =
          disclaimerIconColor;
      }

      const disclaimerText = this.widgetElementRoot.dataset?.disclaimerText;
      if (disclaimerText && disclaimerText !== "") {
        this.disclaimerTextElementRef.textContent = disclaimerText;
        this.handleDisclaimerText();
      }

      const useThemeFont = this.widgetElementRoot.dataset?.useThemeFont;
      const fontFamily =
        typeof useThemeFont === "undefined" ||
        ["false", ""].includes(useThemeFont)
          ? "Poppins"
          : "inherit";

      Array.from(
        document.getElementsByClassName("guide-protection-setting-font-family")
      ).forEach((element) => (element.style.fontFamily = fontFamily));

      // if (this.branding.default_cart === false) {
      //   this.storedWithDefaultUnchecked.push(this.shop);
      // }

      // this.isCheckedByDefault = !this.storedWithDefaultUnchecked.includes(
      //   this.shop
      // );
      this.isCheckedByDefault = false;
    }

    toggleLoader(show = true, controlMainDiv = true) {
      this.spinnerElementRef.style.display = show ? "block" : "none";

      if (controlMainDiv) {
        this.divElementRef.style.display = show ? "none" : "block";
      }
    }

    runningInScriptTag() {
      return WIDGET_HTML !== "" && this.widgetElementRoot;
    }

    setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie =
        name + "=" + encodeURIComponent(value) + expires + "; path=/";
    }

    getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0)
          return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
      return null;
    }

    async handleCheckbox() {
      window.Shopify.inputElementRef.onchange = async () => {
        if (!window.Shopify.variant) {
          return;
        }

        const isChecked = window.Shopify.inputElementRef.checked;

        this.handleToggleDisclaimerText(isChecked);

        const cart = await this.shopifyCart.cart();

        this.setCookie("guide_widget_checked", isChecked, 1);

        const add =
          isChecked &&
          cart.items.length > 0 &&
          !cart.items.find((item) => item.vendor === "Guide");

        const remove =
          !isChecked &&
          cart.items.find(
            (item) => item.variant_id === window.Shopify.variant.id
          );

        if (add) {
          this.shopifyCart.add(window.Shopify.variant.id);
        } else if (remove) {
          this.shopifyCart.update({
            [window.Shopify.variant.id]: 0,
          });
        }
      };
    }

    async handleDisclaimerText() {
      const disclaimerText = this.disclaimerTextElementRef.textContent;
      if (disclaimerText.search("|SHOP_NAME|") !== -1) {
        const shopName = (await this.api.getShop())?.shopify_name;

        this.disclaimerTextElementRef.textContent = disclaimerText.replace(
          "|SHOP_NAME|",
          shopName
        );
      }
    }

    async change() {
      window.Shopify.priceElementRef.innerHTML = window.Shopify.variant?.price;

      this.toggleLoader(false);

      await this.handleCheckbox();

      this.openModalElementRef.onclick = () => {
        this.modalElementRef.style.display = "flex";
      };

      if (this.closeModalElementRef) {
        this.closeModalElementRef.onclick = () => {
          this.modalElementRef.style.display = "none";
        };
      }
    }

    async getBranding() {
      try {
        const response = await fetch(`${API_URL}/branding`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${btoa(API_TOKEN + ":" + this.shop)}`,
            "Content-Type": "application/json",
          },
        });
        const { branding } = await response.json();
        this.branding = branding;
        console.log("branding", branding);
      } catch (err) {
        console.log("Error fetching branding", err);
      }
    }

    async mountWidget(isFetchVariant = false) {
      const cart = await window.Shopify.getCart();
      const addGuideProtectionInput = window.Shopify.inputElementRef;
      const guideItems = cart.items.filter((item) => item.vendor === "Guide");
      const checkedCookie = this.getCookie("guide_widget_checked");
      const onlyGuideProtectionItems = cart.items.length === guideItems.length;
      const hasGuideProtectionOnCart = !!guideItems.length;

      if (!this.runningInScriptTag()) {
        //   this.isCheckedByDefault =
        //     addGuideProtectionInput.dataset.startValue === "true";
        // }

        this.isCheckedByDefault = false;
      }
      const isShouldStartChecked =
        checkedCookie !== null
          ? checkedCookie === "true"
          : this.isCheckedByDefault || hasGuideProtectionOnCart;

      if (!isShouldStartChecked || onlyGuideProtectionItems) {
        addGuideProtectionInput.checked = false;
        this.handleToggleDisclaimerText(false);
        await this.removeAllGuideProtectionItems(guideItems);
        return;
      }

      addGuideProtectionInput.checked = isShouldStartChecked;
      this.handleToggleDisclaimerText(isShouldStartChecked);

      if (isFetchVariant) {
        window.Shopify.variant = await window.Shopify.getVariant(cart);
        window.Shopify.priceElementRef.innerHTML = window.Shopify.variant.price;
      }

      await this.handleFixCheckoutAndAddGuideProtectionItem(guideItems);
    }

    handleToggleDisclaimerText(isChecked) {
      switch (this.disclaimerVisibility) {
        case "always":
          window.Shopify.disclaimerElementRef.style.display = "flex";
          break;
        case "never":
          window.Shopify.disclaimerElementRef.style.display = "none";
          break;
        case "checked":
          window.Shopify.disclaimerElementRef.style.display = isChecked
            ? "flex"
            : "none";
          break;
        case "unchecked":
          window.Shopify.disclaimerElementRef.style.display = !isChecked
            ? "flex"
            : "none";
          break;
        default:
          window.Shopify.disclaimerElementRef.style.display = isChecked
            ? "none"
            : "flex";
          break;
      }
    }

    async removeAllGuideProtectionItems(guideItems) {
      if (!guideItems?.length) {
        return;
      }

      const promises = guideItems.map((item) => {
        {
          return window.Shopify.updateItemOnCart({
            [item.variant_id]: 0,
          });
        }
      });

      await Promise.all(promises);

      location.reload();
    }

    async handleFixCheckoutAndAddGuideProtectionItem(guideItems) {
      const addGuideProtectionInput = window.Shopify.inputElementRef;

      if (!guideItems?.length && addGuideProtectionInput.checked) {
        this.shopifyCart.add(window.Shopify.variant.id);
        return;
      }

      const isNeedToFixed =
        guideItems.length > 1 ||
        guideItems.at(0).variant_id !== window.Shopify.variant.id ||
        guideItems.at(0).quantity > 1;

      if (isNeedToFixed) {
        const promises = guideItems.map(async (item) => {
          if (item.variant_id !== window.Shopify.variant.id) {
            return window.Shopify.updateItemOnCart({
              [item.variant_id]: 0,
              [window.Shopify.variant.id]: 1,
            });
          } else if (item.quantity > 1) {
            return window.Shopify.updateItemOnCart({
              [item.variant_id]: 1,
            });
          }
        });

        await Promise.all(promises);

        location.reload();
      }
    }
  }

  const handleUpdateChart = async () => {
    if (!window.Shopify.variant) {
      return;
    }
    const cart = await window.Shopify.getCart();
    window.Shopify.variant = await window.Shopify.getVariant(cart);
    window.Shopify.priceElementRef.innerHTML = window.Shopify.variant.price;

    const guideItems = cart.items.filter((item) => item.vendor === "Guide");

    if (!guideItems?.length) {
      window.Shopify.addItemToCart(window.Shopify.variant.id);
      return;
    }

    const isNeedToFixed =
      guideItems.length > 1 ||
      guideItems.at(0).variant_id !== window.Shopify.variant.id ||
      guideItems.at(0).quantity > 1;

    if (isNeedToFixed) {
      const promises = guideItems.map(async (item) => {
        if (item.variant_id !== window.Shopify.variant.id) {
          return window.Shopify.updateItemOnCart({
            [item.variant_id]: 0,
            [window.Shopify.variant.id]: 1,
          });
        } else if (item.quantity > 1) {
          return window.Shopify.updateItemOnCart({
            [item.variant_id]: 1,
          });
        }
      });

      await Promise.all(promises);

      location.reload();
    }
  };

  const loadWidget = () => {
    const widget = new Widget(window.Shopify.shop);
    widget.load();
  };

  window.onload = (() => {
    loadWidget();

    const cartWatcher = new CartWatcher();
    cartWatcher.init();
    window.addEventListener("cart_changed", handleUpdateChart);
  })();
}
